import { apiRequest } from './apiHelpers';

const BASE_URL = '/api/e2e/admin/departments';

/**
 * Departments within the reviewing organisation. A department owns E2E forms,
 * and reviewers only see submissions for forms in their own departments.
 * All endpoints require the inera-administrator role.
 */

export const fetchDepartments = async () => {
  const data = await apiRequest(BASE_URL);
  return Array.isArray(data) ? data : [];
};

export const fetchDepartment = (departmentId) =>
  apiRequest(`${BASE_URL}/${encodeURIComponent(departmentId)}`);

export const createDepartment = (payload) =>
  apiRequest(BASE_URL, {
    method: 'POST',
    body: JSON.stringify(payload),
  });

export const updateDepartment = (departmentId, payload) =>
  apiRequest(`${BASE_URL}/${encodeURIComponent(departmentId)}`, {
    method: 'PUT',
    body: JSON.stringify(payload),
  });

export const deleteDepartment = (departmentId) =>
  apiRequest(`${BASE_URL}/${encodeURIComponent(departmentId)}`, {
    method: 'DELETE',
  });

export const fetchDepartmentMembers = async (departmentId) => {
  const data = await apiRequest(`${BASE_URL}/${encodeURIComponent(departmentId)}/members`);
  return Array.isArray(data) ? data : [];
};

export const fetchDepartmentsForUser = async (userId) => {
  const data = await apiRequest(`${BASE_URL}/users/${encodeURIComponent(userId)}`);
  return Array.isArray(data) ? data : [];
};

/**
 * details is optional { name, email } — stored so the member is readable
 * before their first login to the E2E service creates a profile.
 */
export const addDepartmentMember = (departmentId, userId, details = null) =>
  apiRequest(
    `${BASE_URL}/${encodeURIComponent(departmentId)}/members/${encodeURIComponent(userId)}`,
    { method: 'POST', body: JSON.stringify(details || {}) },
  );

export const removeDepartmentMember = (departmentId, userId) =>
  apiRequest(
    `${BASE_URL}/${encodeURIComponent(departmentId)}/members/${encodeURIComponent(userId)}`,
    { method: 'DELETE' },
  );
